<template>
  <div>
    <v-row v-if="!itemId">
      <v-col cols="12">
        <p class="text-18">
          Package {{ source.name }}
        </p>
        <v-tabs
          v-model="tab"
          icons-and-text
          centered
          class="tabs-package"
        >
          <v-tabs-slider class="test" />

          <v-tab
            href="#tab-1"
            class="eg-white-tab white px-10 shadow-lg mr-4 rounded-sm text-body-2 font-weight-bold "
          >
            Package Items ({{ items.length || 0 }})
            <v-icon>mdi-view-list-outline</v-icon>
          </v-tab>

          <v-tab
            href="#tab-2"
            class="eg-white-tab white px-10 shadow-lg mr-4 rounded-sm text-body-2 font-weight-bold "
          >
            Assigned Projects ({{ source.instances.length }})
            <v-icon>mdi-cloud</v-icon>
          </v-tab>

          <v-tab
            href="#tab-3"
            class="eg-white-tab white px-10 shadow-lg rounded-sm text-body-2 font-weight-bold "
          >
            Package Info
            <v-icon>mdi-clipboard-text</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="tab"
          class="mt-0 transparent"
        >
          <v-tab-item value="tab-1">
            <base-card class="">
              <v-card-title>
                <v-select
                  v-model="selectedProject"
                  label="SotalCloud Project"
                  item-text="instanceName"
                  return-object
                  hide-details
                  style="max-width: 250px"
                  clearable
                  :items="source.instances"
                  @change="showAssetIds()"
                />
                <v-spacer />
                <v-text-field
                  v-model.trim="search"
                  append-icon="mdi-magnify"
                  label="Search by name, ID, series ID or name"
                  single-line
                  hide-details
                  clearable
                  style="width: 300px"
                  :class="{'yellow': search }"
                />
                <v-btn
                  outlined
                  small
                  :loading="reportLoaing"
                  :disabled="loading"
                  class="m-l-10"
                  @click="exportXLS()"
                >
                  <i class="mdi mdi-download p-r-5" />
                  Export
                </v-btn>
              </v-card-title>
              <v-data-table
                v-model="selected"
                show-select
                :headers="headers"
                :items="filtered"
                item-key="id"
                class="elevation-1 table-one"
                multi-sort
                :page="page"
                :items-per-page="50"
                :footer-props="{
                  'items-per-page-options': [50, 100, 150],
                  showFirstLastPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                }"
                @current-items="currentItems"
                @update:page="pageUpdate"
              >
                <template v-slot:item.name="{item}">
                  <div class="d-flex align-center">
                    <v-avatar
                      class="mr-2"
                      size="26"
                      dark
                    >
                      <img
                        :src="item.pictureURL"
                        alt=""
                      >
                    </v-avatar>
                    <div>
                      <p class="ma-0 font-weight-medium">
                        {{ item.name }}
                        <a
                          v-if="item.type === 'series'"
                          href="#"
                          class="text-small m-l-10"
                          @click.prevent="search=item.name"
                        >episodes</a>
                      </p>
                    </div>
                  </div>
                </template>
                <template v-slot:item.seriesName="{item}">
                  <p
                    class="ma-0 text--pointer"
                  >
                    <a
                      href="#"
                      @click.prevent="search=item.seriesName"
                    >{{ item.seriesName }}</a>
                  </p>
                </template>
                <template v-slot:item.assetId="{item}">
                  <template v-if="selectedProject && item.assetId > 0">
                    <a
                      :href="'https://epiccue-adm.epicvideo.tech/vod?asset_id=' + item.assetId"
                      target="_blank"
                    >{{ item.assetId }}</a>
                  </template>
                  <template v-else-if="selectedProject && item.deletedInSC">
                    <v-chip
                      class="white--text"
                      color="red"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-minus
                      </v-icon>
                      DELETED IN SC
                    </v-chip>
                  </template>
                  <template v-else-if="item.deleted">
                    <v-chip
                      class="white--text"
                      color="red"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-minus
                      </v-icon>
                      excluded
                    </v-chip>
                  </template>
                  <template v-else-if="item.resultURL !== '' || item.type === 'series'">
                    <v-chip
                      class=""
                      color="success"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-check
                      </v-icon>
                      ok
                    </v-chip>
                    <v-icon
                      v-if="!isItemOK(item)"
                      class="m-l-10"
                      color="warning darken-1"
                    >
                      mdi-alert
                    </v-icon>
                  </template>
                  <template v-else-if="item.state === 'error'">
                    <v-chip
                      class=""
                      color="error"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-warn
                      </v-icon>
                      error
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip
                      class=""
                      color="primary"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                        class="mdi-spin"
                      >
                        mdi-loading
                      </v-icon>
                      processing
                    </v-chip>
                  </template>
                </template>
                <template v-slot:item.action="{item}">
                  <div class="d-flex">
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          class="mr-2"
                          color="success"
                          dark
                          v-bind="attrs"
                          icon
                          v-on="on"
                          @click="goToItem(item)"
                        >
                          <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Details</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          v-bind="attrs"
                          icon
                          v-on="on"
                          @click="editItem(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip
                      v-if="!item.assetCount"
                      top
                    >
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          v-bind="attrs"
                          color="error"
                          icon
                          v-on="on"
                          @click="openDeleteItemDialog(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:item.createTime="{item}">
                  <div class="d-flex align-center text--disabled">
                    {{ moment.utc(item.createTime).format('D MMM YY') }}
                  </div>
                </template>
              </v-data-table>
            </base-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <div class="d-flex justify-end m-b-20">
              <v-btn
                class="white--text primary"
                @click="openAddProjectDialog"
              >
                <v-icon
                  class="transition-none white--text"
                >
                  mdi-plus
                </v-icon>
                Add
              </v-btn>
            </div>
            <base-card
              v-for="instance in source.instances"
              :key="instance.id"
              class="m-b-20"
            >
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-card-title>
                      <v-icon
                        class="m-r-10"
                        color="primary"
                      >
                        mdi-cloud
                      </v-icon>
                      {{ instance.instanceName }}
                    </v-card-title>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="instance.scPackageId"
                      label="SotalCloud Package ID"
                      hint="e.g. 414265"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="instance.cdnTag"
                      label="CDN Tag"
                      hint="e.g. mt-hls"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="instance.vastId"
                      label="VAST ID"
                      hint="e.g. 682777"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="instance.provider"
                      label="Provider"
                      :hint="'e.g. ' + source.name"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="instance.active"
                  color="primary"
                  class="mr-4"
                  :disabled="instance.deleted"
                  @click="syncSourceInstance(instance, false)"
                >
                  <v-icon
                    class="m-r-5"
                  >
                    mdi-pause
                  </v-icon>
                  Stop Sync
                </v-btn>

                <v-btn
                  v-if="!instance.active"
                  color="warning"
                  class="mr-4"
                  :disabled="instance.deleted"
                  @click="syncSourceInstance(instance, true)"
                >
                  <v-icon
                    class="m-r-5"
                  >
                    mdi-play
                  </v-icon>
                  Start Sync
                </v-btn>

                <v-btn
                  color="error"
                  class="mr-4"
                  :disabled="instance.loading"
                  :loading="instance.deleted"
                  @click="deleteSourceInstance(instance)"
                >
                  Delete
                </v-btn>
                <v-spacer />
                <v-btn
                  color="success"
                  class=""
                  :disabled="instance.loading || instance.deleted"
                  @click="patchSourceInstance(instance)"
                >
                  Update
                </v-btn>
              </v-card-actions>
            </base-card>
            <base-card
              v-if="addProjectForm.instance.id && !addInstanceDialog"
              class="m-b-20"
            >
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-card-title>
                      <v-icon
                        class="m-r-10"
                        color="primary"
                      >
                        mdi-cloud
                      </v-icon>
                      {{ addProjectForm.instance.extId }}
                    </v-card-title>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="addProjectForm.scPackageId"
                      label="SotalCloud Package ID"
                      required
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="addProjectForm.cdnTag"
                      label="CDN Tag"
                      required
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="addProjectForm.vastId"
                      label="VAST ID"
                      required
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="error"
                  class="mr-4"
                  text
                  @click="closeAddProjectDialog"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="success"
                  class=""
                  @click="saveNewSourceInstance"
                >
                  Add
                </v-btn>
              </v-card-actions>
            </base-card>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <base-card class="mb-3">
              <v-card-title>{{ source.name }}</v-card-title>
              <v-divider />
              <v-card-text>
                <div>
                  <h6 class="text--disabled">
                    Package Info
                  </h6>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Source:
                    </p>
                    <p
                      class="text-success mb-1 text-18"
                    >
                      <a
                        v-if="source.type === 'excel'"
                        :href="'https://docs.google.com/spreadsheets/d/' + source.url + '/edit'"
                        target="_blank"
                      >{{ 'https://docs.google.com/spreadsheets/d/' + source.url + '/edit' }}</a>
                      <a
                        v-else
                        :href="source.url"
                        target="_blank"
                      >{{ source.url }}</a>
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Last Import Time:
                    </p>
                    <p
                      class="mb-1 text-18 text--disabled"
                    >
                      {{ source.lastImportTime }}
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Transcoding Result Storage:
                    </p>
                    <p
                      class="mb-1 text-18"
                    >
                      {{ source.outputFtpStorage || 'N/A' }}
                    </p>
                  </div>

                  <v-divider class="my-3" />

                  <div
                    class="d-flex justify-space-between"
                  >
                    <h6
                      class=" font-weight-bold mb-1 text-18 mr-2"
                    >
                      Total Items:
                    </h6>
                    <h6 class=" mb-1 text-18">
                      {{ items.length }}
                    </h6>
                  </div>
                </div>
              </v-card-text>
            </base-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <template v-else>
      <h6
        class="pointer"
        @click="backToList"
      >
        <v-icon
          small
          left
        >
          mdi-arrow-left-thick
        </v-icon>
        Back to list
      </h6>
      <v-row v-show="item.id > 0 && item.type !== 'series' && item.resultURL">
        <v-col
          cols="12"
          md="8"
        >
          <video-player
            ref="videoPlayer"
            :src="playerURL"
            @ready="playerReadied"
          />
          <a
            :href="item.resultURL"
            target="_blank"
          >{{ item.resultURL }}</a>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <h6>Poster</h6>
          <img
            height="245"
            :src="item.pictureURL"
            alt=""
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          :md="cardMode ? 12 : 6"
        >
          <div
            class="d-flex justify-space-between align-center flex-wrap"
          >
            <h6>Item</h6>
            <div
              v-if="cardMode"
              class="pb-2"
            >
              <v-btn
                class="mr-2"
                small
                outlined
                color="primary"
                @click="splitView"
              >
                <v-icon>mdi-view-split-vertical</v-icon>
              </v-btn>
              <v-btn
                small
                outlined
                color="primary"
                @click="editView"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </div>
          </div>
          <base-card>
            <v-card-text>
              <v-sheet
                id="scroll-area-2"
                class="overflow-y-auto"
                max-height="1000"
              >
                <div class="d-flex justify-space-between flex-wrap">
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Status:
                  </p>
                  <p class="mb-1">
                    <v-chip
                      v-if="item.deleted"
                      class="white--text"
                      color="red"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-minus
                      </v-icon>
                      excluded
                    </v-chip>
                    <v-chip
                      v-else-if="item.resultURL !== '' && item.type !== 'series'"
                      class=""
                      color="success"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-check
                      </v-icon>
                      transcoded
                    </v-chip>
                    <v-chip
                      v-else-if="item.type === 'series'"
                      class=""
                      color="success"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      >
                        mdi-check
                      </v-icon>
                      ok
                    </v-chip>
                    <v-chip
                      v-else-if="item.state === 'error'"
                      class=""
                      color="error"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                      />
                      error
                    </v-chip>
                    <v-chip
                      v-else
                      class=""
                      color="primary"
                      label
                      small
                    >
                      <v-icon
                        small
                        left
                        class="mdi-spin"
                      >
                        mdi-loading
                      </v-icon>
                      processing
                    </v-chip>
                  </p>
                </div>
                <div
                  v-if="item.error"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Error:
                  </p>
                  <p class="text-red mb-1">
                    {{ item.error }}
                  </p>
                </div>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Name:
                  </p>
                  <p
                    class="text-success mb-1 text-18"
                    :class="{'text-decoration-line-through': item.overwriteName && item.overwriteName !== item.name}"
                  >
                    {{ item.name }}
                  </p>
                </div>
                <div
                  v-if="item.overwriteName && item.overwriteName !== item.name"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Redefined Name:
                  </p>
                  <p class="text-success mb-1 text-18">
                    {{ item.overwriteName }}
                  </p>
                </div>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    ExtID:
                  </p>
                  <p class="mb-0">
                    {{ item.extid }}
                  </p>
                </div>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Description:
                  </p>
                  <p
                    class="mb-0"
                    :class="{'text-decoration-line-through': item.overwriteDescription && item.overwriteDescription !== item.description}"
                  >
                    {{ item.description }}
                  </p>
                </div>
                <div
                  v-if="item.overwriteDescription && item.overwriteDescription !== item.description"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Redefined Description:
                  </p>
                  <p class="mb-0">
                    {{ item.overwriteDescription }}
                  </p>
                </div>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Rotation:
                  </p>
                  <p
                    v-if="item.rotationStart !== '0001-01-01T00:00:00Z'"
                    class="mb-0"
                  >
                    {{ moment.utc(item.rotationStart).format('D MMM YY') }} -
                    {{ moment.utc(item.rotationEnd).format('D MMM YY') }}
                  </p>
                  <p
                    v-else
                    class="mb-0 text--disabled"
                  >
                    N/A
                  </p>
                </div>
                <v-divider class="my-2" />
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Type:
                  </p>
                  <p
                    class="text--disabled mb-0"
                    :class="{'text-decoration-line-through': item.overwriteType && item.overwriteType !== item.type}"
                  >
                    {{ item.type }}
                  </p>
                </div>
                <div
                  v-if="item.overwriteType && item.overwriteType !== item.type"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Redefined Type:
                  </p>
                  <p class="text--disabled mb-0">
                    {{ item.overwriteType }}
                  </p>
                </div>
                <div
                  v-if="item.type === 'episode' || item.overwriteType === 'episode'"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Series ExtID:
                  </p>
                  <p
                    v-if="item.overwriteSeriesExtid"
                    class="mb-0"
                  >
                    {{ item.overwriteSeriesExtid }}
                  </p>
                  <p
                    v-else
                    class="mb-0"
                  >
                    {{ item.seriesExtid || 'N/A' }}
                  </p>
                </div>
                <div
                  v-if="item.type === 'episode' || item.overwriteType === 'episode'"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Season Index:
                  </p>
                  <p
                    v-if="item.overwriteSeasonIndex"
                    class="mb-0"
                  >
                    {{ item.overwriteSeasonIndex }}
                  </p>
                  <p
                    v-else
                    class="mb-0"
                  >
                    {{ item.seasonIndex }}
                  </p>
                </div>
                <div
                  v-if="item.type === 'episode' || item.overwriteType === 'episode'"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-0 mr-2"
                  >
                    Episode Index:
                  </p>
                  <p
                    v-if="item.overwriteEpisodeIndex"
                    class="mb-0"
                  >
                    {{ item.overwriteEpisodeIndex }}
                  </p>
                  <p
                    v-else
                    class="mb-0"
                  >
                    {{ item.episodeIndex }}
                  </p>
                </div>
                <v-divider class="my-2" />
                <div
                  v-if="item.genres && item.genres.length"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Genres:
                  </p>
                  <p class="mb-0">
                    {{ item.genres.join(', ') }}
                  </p>
                </div>
                <div
                  v-if="item.ratings && item.ratings.length"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Ratings:
                  </p>
                  <p class="mb-0">
                    {{ item.ratings.join(', ') }}
                  </p>
                </div>
                <div
                  v-if="item.year"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Year:
                  </p>
                  <p class="mb-0">
                    {{ item.year }}
                  </p>
                </div>
                <div
                  v-if="item.persons && item.persons.length"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Cast & Crew:
                  </p>
                  <p class="mb-0">
                    {{ item.persons.join(', ') }}
                  </p>
                </div>
                <div
                  v-if="item.studio"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Studio:
                  </p>
                  <p class="mb-0">
                    {{ item.studio }}
                  </p>
                </div>
                <div
                  v-if="item.country"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Country:
                  </p>
                  <p class="mb-0">
                    {{ item.country }}
                  </p>
                </div>
                <div
                  v-if="item.imdb"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    IMDB:
                  </p>
                  <p class="mb-0">
                    {{ item.imdb }}
                  </p>
                </div>
                <v-divider class="my-2" />
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Created:
                  </p>
                  <p class="mb-0">
                    {{ moment.utc(item.createTime).format('D MMM YY') }}
                  </p>
                </div>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Updated:
                  </p>
                  <p class="mb-0">
                    {{ moment.utc(item.updateTime).format('D MMM YY') }}
                  </p>
                </div>
                <v-divider class="my-2" />
                <div
                  v-if="item.videoSourceURL"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Video Source URL:
                  </p>
                  <p class="mb-0">
                    <a
                      :href="item.videoSourceURL"
                      class="text-decoration-underline"
                      target="_blank"
                    >{{ item.videoSourceURL }}</a>
                    <span
                      v-if="!isURLValid(item.videoSourceURL)"
                      class="orange"
                    >NOT FOUND</span>
                  </p>
                </div>
                <div
                  v-if="item.subtitleURL"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Subtitle URL:
                  </p>
                  <p class="mb-0">
                    <a
                      :href="item.subtitleURL"
                      class="text-decoration-underline"
                      target="_blank"
                    >{{ item.subtitleURL }}</a>
                    <span
                      v-if="!isURLValid(item.subtitleURL)"
                      class="orange"
                    >NOT FOUND</span>
                  </p>
                </div>
                <div
                  v-if="item.cuepoints && item.cuepoints.length"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Cuepoints:
                  </p>
                  <p class="mb-0">
                    {{ item.cuepoints.join(', ') }}
                  </p>
                </div>
                <div
                  v-if="item.distribURL"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Result Video URL:
                  </p>
                  <p class="mb-0">
                    <a
                      :href="item.distribURL"
                      class="text-decoration-underline"
                      target="_blank"
                    >{{ item.distribURL }}</a>
                  </p>
                </div>
                <div
                  v-if="item.trailerVideoSourceURL"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Trailer Source URL:
                  </p>
                  <p class="mb-0">
                    <a
                      :href="item.trailerVideoSourceURL"
                      class="text-decoration-underline"
                      target="_blank"
                    >{{ item.trailerVideoSourceURL }}</a>
                    <span
                      v-if="!isURLValid(item.trailerVideoSourceURL)"
                      class="orange"
                    >NOT FOUND</span>
                  </p>
                </div>
                <div
                  v-if="item.trailerDistribURL"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Result Trailer Video URL:
                  </p>
                  <p class="mb-0">
                    <a
                      :href="item.trailerDistribURL"
                      class="text-decoration-underline"
                      target="_blank"
                    >{{ item.trailerDistribURL }}</a>
                  </p>
                </div>
                <v-divider class="my-2" />
                <div
                  v-if="item.pictures"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 mr-2"
                  >
                    Pictures:
                  </p>
                  <p
                    class="mb-0"
                  >
                    <span v-if="item.pictureVertical">
                      <a
                        :href="item.pictureVertical"
                        class="text-decoration-underline"
                        :class="{'text-decoration-line-through': item.overwritePictureVertical}"
                        target="_blank"
                      >{{ item.pictureVertical }}</a> (vertical)
                      <span
                        v-if="!isURLValid(item.pictureVertical)"
                        class="orange"
                      >NOT FOUND
                      </span>
                    </span>
                    <span v-if="item.overwritePictureVertical">
                      <a
                        :href="item.overwritePictureVertical"
                        class="text-decoration-underline"
                        target="_blank"
                      >{{ item.overwritePictureVertical }}</a> (vertical)
                      <span
                        v-if="!isURLValid(item.overwritePictureVertical)"
                        class="orange"
                      >NOT FOUND
                      </span>
                    </span>
                    <span v-if="item.pictureHorizontal">
                      <a
                        :href="item.pictureHorizontal"
                        :class="{'text-decoration-line-through': item.overwritePictureHorizontal}"
                        class="text-decoration-underline"
                        target="_blank"
                      >{{ item.pictureHorizontal }}</a> (horizontal)
                      <span
                        v-if="!isURLValid(item.pictureHorizontal)"
                        class="orange"
                      >NOT FOUND
                      </span>
                    </span>
                    <span v-if="item.overwritePictureHorizontal">
                      <a
                        :href="item.overwritePictureHorizontal"
                        class="text-decoration-underline"
                        target="_blank"
                      >{{ item.overwritePictureHorizontal }}</a> (horizontal)
                      <span
                        v-if="!isURLValid(item.overwritePictureHorizontal)"
                        class="orange"
                      >NOT FOUND
                      </span>
                    </span>
                  </p>
                </div>
              </v-sheet>
            </v-card-text>
          </base-card>
        </v-col>

        <v-col
          v-show="!editMode && !cardMode"
          cols="12"
          md="6"
        >
          <div
            class="d-flex justify-space-between align-center flex-wrap"
          >
            <h6>Source Metadata</h6>
            <div class="pb-2">
              <v-btn
                class="mr-2"
                small
                outlined
                color="primary"
                @click="cardView"
              >
                <v-icon>mdi-card-outline</v-icon>
              </v-btn>
              <v-btn
                small
                outlined
                color="primary"
                @click="editView"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </div>
          </div>

          <v-sheet
            id="scroll-area-1"
            class="overflow-y-auto"
            max-height="850"
          >
            <pre
              class="text-body-2"
              style="font-family: Hack, Consolas, Menlo, Monaco, Console, Courier, monospace; font-size: 14px; line-height: 1.375; color: #454242"
            >
            {{ item.metadata }}
          </pre>
          </v-sheet>
        </v-col>

        <v-col
          v-show="editMode"
          cols="12"
          md="6"
        >
          <div
            class="d-flex justify-space-between align-center flex-wrap"
          >
            <h6>Overwrite Metadata</h6>
            <div class="pb-2">
              <v-btn
                class="mr-2"
                small
                outlined
                color="primary"
                @click="cardView"
              >
                <v-icon>mdi-card-outline</v-icon>
              </v-btn>
              <v-btn
                small
                outlined
                color="primary"
                @click="splitView"
              >
                <v-icon>mdi-view-split-vertical</v-icon>
              </v-btn>
            </div>
          </div>
          <base-card>
            <v-card-text>
              <div class="d-flex justify-space-between mb-2">
                <h2 class="text-16">
                  Choose fields
                </h2>
                <v-btn
                  class="white--text"
                  color="primary"
                  depressed
                  @click="saveEditFullForm"
                >
                  Save
                  <v-icon right>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </div>

              <v-chip-group
                v-model="selectedFields"
                column
                multiple
                class="mb-2"
                @change="changeFieldSelection"
              >
                <v-chip
                  filter
                  outlined
                >
                  Title
                </v-chip>
                <v-chip
                  filter
                  outlined
                >
                  Description
                </v-chip>
                <v-chip
                  filter
                  outlined
                >
                  Type
                </v-chip>
                <v-chip
                  filter
                  outlined
                >
                  Rotation Period
                </v-chip>
                <v-chip
                  filter
                  outlined
                >
                  Pictures
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Rating
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Genres
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Persons
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Year
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Studio
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Country
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  IMDB
                </v-chip>
                <v-chip
                  filter
                  disabled
                  outlined
                >
                  Subtitle URL
                </v-chip>
              </v-chip-group>

              <v-sheet
                id="scroll-area-2"
                class="overflow-y-auto"
                max-height="1000"
              >
                <div
                  v-if="editForm.showTitle"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <v-text-field
                    v-model.trim="editForm.title"
                    color="success"
                    label="Title"
                  />
                </div>
                <div
                  v-if="editForm.showDescription"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <v-textarea
                    v-model.trim="editForm.description"
                    filled
                    auto-grow
                    label="Description"
                    rows="2"
                    row-height="30"
                    hide-details
                  />
                </div>
                <div
                  v-if="editForm.showRotation"
                  class="d-flex justify-space-between flex-wrap mt-2"
                >
                  <p
                    class="mb-0"
                  >
                    <v-dialog
                      ref="rotStartDialog"
                      v-model="editForm.editRotationStart"
                      :return-value.sync="editForm.rotationStart"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{on, attrs}">
                        <v-text-field
                          v-model="editForm.rotationStart"
                          label="Rotation Start"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="editForm.rotationStart"
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="editForm.editRotationStart = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.rotStartDialog.save(editForm.rotationStart)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </p>
                  <p class="mb-0">
                    <v-dialog
                      ref="rotEndDialog"
                      v-model="editForm.editRotationEnd"
                      :return-value.sync="editForm.rotationEnd"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{on, attrs}">
                        <v-text-field
                          v-model="editForm.rotationEnd"
                          label="Rotation End"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="editForm.rotationEnd"
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="editForm.editRotationEnd = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.rotEndDialog.save(editForm.rotationEnd)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </p>
                </div>
                <div
                  v-if="editForm.showType"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p class="mb-0">
                    <v-radio-group
                      v-model="editForm.type"
                      :mandatory="false"
                      row
                      hide-details
                      class="p-l-10"
                    >
                      <v-radio
                        label="Series"
                        value="series"
                        hide-details
                      />
                      <v-radio
                        label="Movie"
                        value="movie"
                        hide-details
                      />
                      <v-radio
                        label="Episode"
                        value="episode"
                        hide-details
                      />
                    </v-radio-group>
                  </p>
                </div>
                <div
                  v-if="editForm.showType && editForm.type === 'episode'"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="mb-0"
                    style="width: 55%"
                  >
                    <v-select
                      v-model="editForm.seriesExtid"
                      item-text="name"
                      item-value="extid"
                      label="Series"
                      append-outer-icon="mdi-plus"
                      prepend-icon="mdi-film"
                      hide-details
                      :items="series"
                      @click:append-outer="addSeries"
                    />
                  </p>
                  <p
                    class="mb-0"
                    style="width: 20%"
                  >
                    <v-text-field
                      v-model="editForm.seasonIndex"
                      label="Season Index"
                      type="number"
                    />
                  </p>
                  <p
                    class="mb-0"
                    style="width: 20%"
                  >
                    <v-text-field
                      v-model="editForm.episodeIndex"
                      label="Episode Index"
                      type="number"
                    />
                  </p>
                </div>
                <v-divider
                  v-if="editForm.showType"
                  class="my-2 p-b-20"
                />
                <div
                  v-if="editForm.showPosters"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <div style="width: 10%;">
                    <v-file-input
                      hide-input
                      prepend-icon="mdi-upload"
                      class="p-l-10"
                    />
                  </div>
                  <div
                    style="word-break: break-all; width: 90%;"
                  >
                    <v-text-field
                      v-model.trim="editForm.verticalPosterURL"
                      color="primary"
                      hide-details
                      style="width: 98%"
                      label="Vertical Poster URL"
                      append-outer-icon="mdi-open-in-new"
                      @click:append-outer="openURL()"
                    />
                    <v-btn
                      v-if="false"
                      x-small
                    >
                      Select from FTP
                    </v-btn>
                  </div>
                </div>
                <div
                  v-if="editForm.showPosters"
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p style="word-break: break-all; width: 10%">
                    <v-file-input
                      hide-input
                      color="primary"
                      prepend-icon="mdi-upload"
                      class="p-l-10"
                    />
                  </p>
                  <p
                    style="word-break: break-all; width: 90%"
                  >
                    <v-text-field
                      v-model.trim="editForm.horizontalPosterURL"
                      label="Horizontal Poster URL"
                      append-outer-icon="mdi-open-in-new"
                      hide-details
                      color="primary"
                      style="width: 98%"
                      @click:append-outer="openURL()"
                    />
                    <v-btn
                      v-if="false"
                      x-small
                    >
                      Select from FTP
                    </v-btn>
                  </p>
                </div>
              </v-sheet>
            </v-card-text>
          </base-card>
        </v-col>
      </v-row>
    </template>

    <v-snackbar
      :value="selected.length"
      timeout="-1"
    >
      Selected items: {{ selected.length }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="selected = []"
        >
          cancel
        </v-btn>
        <v-btn
          v-if="!selectedProject"
          color="red"
          text
          v-bind="attrs"
          :disabled="excluding"
          @click="excludeItemsDialog"
        >
          Exclude
        </v-btn>
        <v-btn
          v-if="selectedProject"
          color="orange"
          text
          v-bind="attrs"
          :loading="reimporting"
          @click="reimportItems"
        >
          Re-Import Into {{ selectedProject.instanceName }}
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Add Instance  -->
    <v-dialog
      v-model="addInstanceDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">New Assignment</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-select
                  v-model="addProjectForm.instance"
                  label="SotalCloud Project"
                  item-text="extId"
                  return-object
                  outlined
                  :items="addProjectInstances"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeAddProjectDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !addProjectForm.instance.id"
            @click="addInstance"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit VOD</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model.trim="editedItem.name"
                  label="VOD Title"
                />
                <v-radio-group
                  v-if="editedItem.type === 'episode' || editedItem.type === 'movie'"
                  v-model="editedItem.type"
                  :mandatory="false"
                  row
                  hide-details
                >
                  <v-radio
                    label="Movie"
                    value="movie"
                  />
                  <v-radio
                    label="Episode"
                    value="episode"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                v-if="editedItem.type === 'episode'"
                cols="12"
                md="12"
              >
                <v-select
                  v-model="editedItem.seriesExtid"
                  item-text="name"
                  item-value="extid"
                  label="Series"
                  append-outer-icon="mdi-plus"
                  hide-details
                  :items="series"
                  @click:append-outer="addSeries"
                />
              </v-col>
              <v-col
                v-if="editedItem.type === 'episode'"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.seasonIndex"
                  label="Season Index"
                  type="number"
                />
              </v-col>
              <v-col
                v-if="editedItem.type === 'episode'"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.episodeIndex"
                  label="Episode Index"
                  type="number"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeEditDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            dark
            color="primary"
            :loading="editLoading"
            @click="saveEditedItemShortForm"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="newSeriesDialog"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">New Series</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model.trim="newSeries.name"
                  label="Title"
                />
                <v-textarea
                  v-model.trim="newSeries.description"
                  rows="2"
                  label="Description"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeNewSeriesDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            dark
            color="primary"
            :disabled="!newSeries.name.length"
            :loading="editLoading"
            @click="addNewSeries"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="instanceRemoveDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete instance?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to remove all assets of the package from the instance <strong>{{ deletedInstance.instanceName }}</strong> and stop ingesting into this project?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="instanceRemoveDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteInstanceSource()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Exclude Dialog -->
    <v-dialog
      v-model="excludingDialog"
      max-width="500"
      persistent
      :disabled="excluding"
    >
      <v-card>
        <v-card-title class="text-h5">
          Exclude?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to exclude selected items?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            :disabled="excluding"
            @click="excludingDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            :disabled="excluding"
            @click="excludeItems()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="itemRemoveDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete item?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the item <strong>{{ deletedItem.name }}</strong>?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="itemRemoveDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteItem()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import videoPlayer from '@/player/player'
  import moment from 'moment-timezone'
  import { processInstance, processSource, processSourceInstance } from '@/store/converters'

  function processItem (item) {
    const processed = {
      id: item.id,
      name: item.name,
      description: item.description || '',
      extid: item.ext_id,
      createTime: item.added,
      updateTime: item.update_time,
      assetId: item.asset_id || 0,
      type: item.type,
      rotationStart: item.rotation_start,
      rotationEnd: item.rotation_end,
      seriesExtid: item.series_id || '',
      seriesName: '',
      seriesIndex: '',
      state: item.state || '',
      error: item.error || '',
      year: item.year || 0,
      resultURL: item.result_url || '',
      deleted: item.deleted || false,
      seasonIndex: item.s_ind || 0,
      episodeIndex: item.ep_ind || 0,
      pictureURL: item.picture_url || '',
      genres: item.genres || [],
      ratings: item.ratings || [],
      persons: item.persons || [],
      studio: item.studio || '',
      country: item.country || '',
      imdb: item.imdb || 0,
      videoSourceURL: item.video_source_url || '',
      trailerVideoSourceURL: item.trailer_video_source_url || '',
      distribURL: item.distrib_url || '',
      trailerDistribURL: item.trailer_distrib_url || '',
      cuepoints: item.cuepoints || [],
      pictures: item.pictures,
      pictureHorizontal: item.picture_horizontal || '',
      pictureVertical: item.picture_vertical || '',
      overwriteType: item.overwrite_type || '',
      overwriteName: item.overwrite_name || '',
      overwriteDescription: item.overwrite_description || '',
      overwriteSeriesExtid: item.overwrite_series_id || '',
      overwriteEpisodeIndex: item.overwrite_ep_ind || 0,
      overwriteSeasonIndex: item.overwrite_s_ind || 0,
      overwritePictureVertical: item.overwrite_picture_vertical || '',
      overwritePictureHorizontal: item.overwrite_picture_horizontal || '',
      overwriteRotationStart: item.overwrite_rotation_start,
      overwriteRotationEnd: item.overwrite_rotation_end,
      deletedInSC: false,
      subtitleURL: item.subtitle_url || '',
      assetCount: item.asset_count || 0,
    }
    if (item.type === 'episode') {
      processed.seriesIndex = 's' + processed.seasonIndex + 'e' + processed.episodeIndex
    }
    if (!item.picture_url && item.pictures) {
      for (const pic in item.pictures) {
        processed.pictureURL = item.pictures[pic]
        break
      }
    }
    if (item.metadata) {
      processed.metadata = JSON.parse(item.metadata)
    }
    return processed
  }

  export default {
    name: 'Package',
    metaInfo: {
      title: 'Package',
    },
    components: {
      videoPlayer,
    },
    data () {
      return {
        tab: null,
        selected: [],
        displayed: [],
        page: 1,
        polling: null,
        search: '',
        items: [],
        series: [],
        headers: [
          {
            text: 'Title',
            align: 'start',
            value: 'name',
          },
          { text: 'Status', value: 'assetId' },
          { text: 'Type', value: 'type' },
          { text: 'Series Name', value: 'seriesName' },
          { text: 'Create Date', value: 'createTime' },
          { text: 'Index', value: 'seriesIndex' },
          { text: 'Action', value: 'action' },
        ],
        itemId: null,
        playerURL: '',
        item: {
          metadata: '',
          genres: [],
        },
        player: null,
        reportLoaing: false,
        source: {
          instances: [],
        },
        instances: [],
        addProjectInstances: [],
        addProjectForm: {
          instance: {},
          cdnTag: '',
          scPackageId: '',
          vastId: '',
        },
        addInstanceDialog: false,
        excluding: false,
        excludingDialog: false,
        reimporting: false,
        editedIndex: -1,
        editedItem: {},
        editDialog: false,
        editLoading: false,
        newSeriesDialog: false,
        selectedProject: null,
        newSeries: {
          name: '',
          description: '',
        },
        editMode: true,
        cardMode: false,
        overlay: false,
        overlay2: false,
        selectedFields: [],
        editForm: {
          id: 0,
          title: '',
          showTitle: false,
          description: '',
          showDescription: false,
          rotationStart: null,
          rotationEnd: null,
          editRotationStart: false,
          editRotationEnd: false,
          showRotation: false,
          type: '',
          seriesExtid: '',
          seasonIndex: '',
          episodeIndex: '',
          showType: false,
          verticalPosterURL: '',
          horizontalPosterURL: '',
          showPosters: false,
        },
        instanceRemoveDialog: false,
        deletedInstance: {},
        itemRemoveDialog: false,
        deletedItem: {},
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      totalChannels () {
        return this.channels.length
      },
      filtered () {
        if (!this.search) {
          return this.items
        }
        return this.items.filter((item) => {
          const searchTerm = this.search.toLowerCase().trim()
          let inc = false
          if (item.name.toLowerCase().includes(searchTerm)) {
            inc = true
          }
          if (item.extid.toLowerCase().includes(searchTerm)) {
            inc = true
          }
          const assetId = item.assetId + ''
          if (assetId.toLowerCase().includes(searchTerm)) {
            inc = true
          }
          if (item.seriesExtid && item.seriesExtid.toLowerCase().includes(searchTerm)) {
            inc = true
          }
          if (item.seriesName && item.seriesName.toLowerCase().includes(searchTerm)) {
            inc = true
          }
          return inc
        })
      },
    },
    watch: {
      search () {
        this.changeRoute(this.page)
      },
      '$route' (to, from) {
        this.parseQuery()
      },
    },
    created () {
      this.loadData(this.$route.params.package_id)
      this.pollData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      parseQuery () {
        const { page } = this.$route.query
        if (page) {
          this.page = Number(page) || 0
        }
        const { search } = this.$route.query
        if (search) {
          this.search = search
        }
        // eslint-disable-next-line camelcase
        const { item_id } = this.$route.query
        this.itemId = item_id
        if (this.itemId) {
          this.getItem(this.itemId)
        }
      },
      changeRoute (page) {
        const newQuery = {
          page: `${page}`,
          search: this.search,
        }
        if (this.itemId) {
          newQuery.item_id = this.itemId
        }
        if (JSON.stringify(this.$route.query) === JSON.stringify(newQuery)) return
        this.$router.push({
          query: newQuery,
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      pageUpdate (page) {
        this.changeRoute(page)
      },
      currentItems (items) {
        const id = []
        for (let i = 0; i < items.length; i += 1) {
          id.push(items[i].id)
        }

        const itemsPicturesReq = this.$store.dispatch('itemsPictures', {
          id: id.join(','),
        })

        Promise.all([itemsPicturesReq])
          .then((result) => {
            const respList = result[0] || []
            const picMap = {}
            for (let i = 0; i < respList.length; i += 1) {
              picMap[respList[i].id] = respList[i].pic_url
            }

            for (let i = 0; i < items.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (picMap.hasOwnProperty(items[i].id)) {
                items[i].pictureURL = picMap[items[i].id]
              }
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      loadData (sourceId) {
        this.$store.commit('setPageLoader')

        const params = {
          'source.id[eq]': sourceId,
          $orderby: 'id',
          'type[neq]': 'season',
          $expand: 'asset_count',
          //$limit: 100,
        }
        const sourceReq = this.$store.dispatch('getSourceById', { id: sourceId })

        const itemsReq = this.$store.dispatch('items', params)

        const instancesReq = this.$store.dispatch('instances', {})

        Promise.all([sourceReq, itemsReq, instancesReq])
          .then((result) => {
            const source = result[0] || {}
            this.source = processSource(source)

            const items = result[1] || []
            const processed = []
            const seriesMap = {}
            for (let i = 0; i < items.length; i += 1) {
              const item = processItem(items[i])
              processed.push(item)
              if (item.type === 'series') {
                seriesMap[item.extid] = item.name
                this.series.push({
                  extid: item.extid,
                  name: item.name,
                })
              }
            }
            for (let i = 0; i < processed.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (seriesMap.hasOwnProperty(processed[i].seriesExtid)) {
                processed[i].seriesName = seriesMap[processed[i].seriesExtid]
              }
            }
            this.items = processed

            this.parseQuery()

            const instances = result[2] || []
            for (let i = 0; i < instances.length; i += 1) {
              const instance = processInstance(instances[i])
              this.instances.push(instance)
            }

            this.getSourceInstances()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      isItemOK (item) {
        if (item.overwritePictureVertical) {
          const pic = item.overwritePictureVertical
          if (!(pic.startsWith('ftp') || pic.startsWith('http'))) {
            return false
          }
        } else if (item.pictureVertical) {
          const pic = item.pictureVertical
          if (!(pic.startsWith('ftp') || pic.startsWith('http'))) {
            return false
          }
        }
        if (item.overwritePictureHorizontal) {
          const pic = item.overwritePictureHorizontal
          if (!(pic.startsWith('ftp') || pic.startsWith('http'))) {
            return false
          }
        } else if (item.pictureHorizontal) {
          const pic = item.pictureHorizontal
          if (!(pic.startsWith('ftp') || pic.startsWith('http'))) {
            return false
          }
        }
        return true
      },
      isURLValid (sourceURL) {
        return sourceURL.startsWith('ftp') || sourceURL.startsWith('http')
      },
      getItem (id) {
        this.$store.commit('setPageLoader')

        const params = {
          id: id,
        }
        const itemsReq = this.$store.dispatch('getItemById', params)

        this.setPlayerURL('___')

        Promise.all([itemsReq])
          .then((result) => {
            const item = result[0] || {}

            this.item = processItem(item)
            if (this.item !== 'series') {
              this.setPlayerURL(this.item.resultURL)
            }

            console.log('item', this.item)

            this.fillEditForm(this.item)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 5000,
              color: 'error',
            })
            this.itemId = null
            this.changeRoute(this.page)
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getSourceInstances () {
        this.source.instances = []

        const params = {
          'source_id[eq]': this.source.id,
        }
        const sourceInstancesReq = this.$store.dispatch('sourceInstances', params)

        Promise.all([sourceInstancesReq])
          .then((result) => {
            const instanceMap = {}
            for (let i = 0; i < this.instances.length; i += 1) {
              instanceMap[this.instances[i].id] = this.instances[i].extId
            }

            const sourceInstances = result[0] || {}
            for (let i = 0; i < sourceInstances.length; i += 1) {
              const instance = processSourceInstance(sourceInstances[i])
              // eslint-disable-next-line no-prototype-builtins
              if (instanceMap.hasOwnProperty(instance.instanceId)) {
                instance.instanceName = instanceMap[instance.instanceId]
              }
              this.source.instances.push(instance)
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 5000,
              color: 'error',
            })
          })
      },
      pollData () {
        this.polling = setInterval(() => {
        // this.loadData();
        }, 10000)
      },
      goToItem (item) {
        this.itemId = item.id
        this.changeRoute(this.page)
        this.getItem(item.id)
      },
      playerReadied (player) {
        this.player = player
      },
      setPlayerURL (url) {
        this.playerURL = url
      },
      exportXLS () {
        this.reportLoaing = true

        const params = {
          source_id: this.source.id,
        }

        this.$store.dispatch('getPackageReport', params)
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Package ' + this.source.name + ' Assets'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => this.reportLoaing = false)
      },
      openAddProjectDialog () {
        this.addProjectForm.instance = {}
        this.addProjectForm.cdnTag = ''
        this.addProjectForm.scPackageId = ''
        this.addProjectForm.vastId = ''

        this.addProjectInstances = []

        const existing = {}
        for (let i = 0; i < this.source.instances.length > 0; i += 1) {
          existing[this.source.instances[i].instanceId] = true
        }

        console.log('this.instances', this.instances)
        for (let i = 0; i < this.instances.length > 0; i += 1) {
          // eslint-disable-next-line no-prototype-builtins
          if (existing.hasOwnProperty(this.instances[i].id)) {
            continue
          }
          this.addProjectInstances.push(this.instances[i])
        }

        console.log('addProjectInstances', this.addProjectInstances)
        this.addInstanceDialog = true
      },
      addInstance () {
        this.addInstanceDialog = false
      },
      closeAddProjectDialog () {
        this.addProjectForm.instance = {}
        this.addProjectForm.cdnTag = ''
        this.addProjectForm.scPackageId = ''
        this.addProjectForm.vastId = ''
        this.addInstanceDialog = false
      },
      saveNewSourceInstance () {
        this.$store.commit('setPageLoader')

        const sourceInstance = {
          source_id: this.source.id,
          instance_id: this.addProjectForm.instance.id,
          active: false,
          sc_package_extid: this.addProjectForm.scPackageId,
          sc_cdn_tag: this.addProjectForm.cdnTag,
          sc_vast_id: this.addProjectForm.vastId,
        }

        this.$store.dispatch('createSourceInstance', sourceInstance)
          .then((pack) => {
            this.$store.commit('showSnackbar', {
              text: 'The project has been assigned',
              timeout: 3000,
              color: 'success',
            })
            this.closeAddProjectDialog()
            this.getSourceInstances()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      syncSourceInstance (sourceInstance, action) {
        sourceInstance.active = action

        const updated = {
          id: sourceInstance.id,
          active: sourceInstance.active,
        }

        this.$store.dispatch('updateSourceInstance', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The project has been updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
          })
      },
      patchSourceInstance (sourceInstance) {
        const updated = {
          id: sourceInstance.id,
          sc_package_extid: sourceInstance.scPackageId,
          sc_cdn_tag: sourceInstance.cdnTag,
          sc_vast_id: sourceInstance.vastId,
          provider: sourceInstance.provider,
          update_required: true,
        }

        sourceInstance.loading = true

        this.$store.dispatch('refreshSourceInstance', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The project has been updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            sourceInstance.loading = false
          })
      },
      backToList () {
        this.itemId = null
        this.changeRoute(this.page)
      },
      excludeItemsDialog () {
        this.excludingDialog = true
      },
      excludeItems () {
        if (this.selected.length === 0) return

        this.excluding = true

        const itemMap = {}
        for (let i = 0; i < this.selected.length; i += 1) {
          itemMap[this.selected[i].id] = true
        }

        const ids = []
        for (let i = 0; i < this.selected.length; i += 1) {
          ids.push(this.selected[i].id)
        }

        this.$store.dispatch('excludeItems', ids)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The items have been successfully excluded',
              timeout: 6000,
              color: 'success',
            })
            for (let i = 0; i < this.items.length; i += 1) {
              const item = this.items[i]
              if (item.deleted) continue
              // eslint-disable-next-line no-prototype-builtins
              if (itemMap.hasOwnProperty(item.id)) {
                item.deleted = true
              }
            }
            this.selected = []
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.excluding = false
            this.excludingDialog = false
          })
      },
      reimportItems () {
        if (this.selected.length === 0) return

        this.reimporting = true

        const ids = []
        for (let i = 0; i < this.selected.length; i += 1) {
          ids.push(this.selected[i].id)
        }

        const params = {
          instanceId: this.selectedProject.instanceId,
          selected: ids,
        }

        this.$store.dispatch('reimportItems', params)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The items have been successfully re-imported',
              timeout: 6000,
              color: 'success',
            })
            this.selected = []
            this.showAssetIds()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.reimporting = false
          })
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editDialog = true
      },
      closeEditDialog () {
        this.editDialog = false
        this.editedItem = Object.assign({}, {})
        this.editedIndex = -1
      },
      saveEditedItemShortForm () {
        if (this.editedItem.type === 'episode' && !this.editedItem.seriesExtid) {
          return
        }

        this.editLoading = true

        const updated = {
          id: this.editedItem.id,
          name: this.editedItem.name,
          type: this.editedItem.type,
        }

        if (this.editedItem.type === 'episode') {
          updated.series_id = this.editedItem.seriesExtid
          updated.s_ind = Number(this.editedItem.seasonIndex)
          updated.ep_ind = Number(this.editedItem.episodeIndex)
        }

        this.$store.dispatch('patchItem', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The item has been updated',
              timeout: 3000,
              color: 'success',
            })

            for (let i = 0; i < this.items.length; i += 1) {
              if (this.items[i].id === this.editedItem.id) {
                this.items[i].name = this.editedItem.name
                this.items[i].type = this.editedItem.type
                this.items[i].seriesExtid = this.editedItem.seriesExtid
                this.items[i].seasonIndex = this.editedItem.seasonIndex
                this.items[i].episodeIndex = this.editedItem.episodeIndex
                this.items[i].seriesIndex = 's' + this.editedItem.seasonIndex + 'e' + this.editedItem.episodeIndex
                this.items[i].seriesName = this.editedItem.seriesExtid
                break
              }
            }
            this.closeEditDialog()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.editLoading = false
          })
      },
      saveEditFullForm () {
        const patchedItem = {
          id: this.editForm.id,
          name: '',
          description: '',
          type: '',
          series_id: '',
          s_ind: 0,
          ep_ind: 0,
          rotation_start: '0001-01-01T00:00:00Z',
          rotation_end: '0001-01-01T00:00:00Z',
        }

        if (this.editForm.showTitle && this.editForm.title) {
          patchedItem.name = this.editForm.title
        }
        if (this.editForm.showDescription && this.editForm.description) {
          patchedItem.description = this.editForm.description
        }
        if (this.editForm.showType) {
          patchedItem.type = this.editForm.type
          if (this.editForm.type === 'episode') {
            if (this.editForm.seriesExtid) {
              patchedItem.series_id = this.editForm.seriesExtid
            }
            if (this.editForm.seasonIndex) {
              patchedItem.s_ind = Number(this.editForm.seasonIndex)
            }
            if (this.editForm.episodeIndex) {
              patchedItem.ep_ind = Number(this.editForm.episodeIndex)
            }
          }
        }

        if (this.editForm.showRotation) {
          if (this.editForm.rotationStart) {
            patchedItem.rotation_start = this.editForm.rotationStart + 'T00:00:00Z'
          }
          if (this.editForm.rotationEnd) {
            patchedItem.rotation_end = this.editForm.rotationEnd + 'T00:00:00Z'
          }
        }

        this.$store.dispatch('patchItem', patchedItem)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The item has been updated',
              timeout: 3000,
              color: 'success',
            })

            this.getItem(this.editForm.id)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
          })
      },
      fillEditForm (item) {
        this.editForm.id = item.id

        this.editForm.title = ''
        this.editForm.showTitle = false
        this.editForm.showType = false
        this.editForm.type = ''
        this.editForm.seriesExtid = ''
        this.editForm.seasonIndex = ''
        this.editForm.episodeIndex = ''
        this.editForm.description = ''
        this.editForm.showDescription = false
        this.editForm.rotationStart = null
        this.editForm.rotationEnd = null
        this.editForm.editRotationStart = false
        this.editForm.editRotationEnd = false
        this.editForm.showRotation = false
        this.editForm.verticalPosterURL = ''
        this.editForm.horizontalPosterURL = ''
        this.editForm.showPosters = false

        this.selectedFields = []

        if (item.overwriteType) {
          this.editForm.showType = true
          this.selectedFields.push(2)
          this.editForm.type = item.overwriteType
        } else {
          this.editForm.type = item.type
        }

        if (this.editForm.type === 'episode') {
          if (item.overwriteSeriesExtid) {
            this.editForm.seriesExtid = item.overwriteSeriesExtid
          }
          if (item.overwriteSeasonIndex) {
            this.editForm.seasonIndex = item.overwriteSeasonIndex
          }
          if (item.overwriteEpisodeIndex) {
            this.editForm.episodeIndex = item.overwriteEpisodeIndex
          }
        }

        if (item.overwriteName) {
          this.editForm.showTitle = true
          this.selectedFields.push(0)
          this.editForm.title = item.overwriteName
        }

        if (item.overwriteDescription) {
          this.editForm.showDescription = true
          this.selectedFields.push(1)
          this.editForm.description = item.overwriteDescription
        }

        if (item.overwriteRotationStart) {
          const rotationStart = `${moment(item.overwriteRotationStart).utc().format('YYYY-MM-DD')}`
          if (rotationStart !== '0001-01-01') {
            this.editForm.showRotation = true
            this.selectedFields.push(3)
            this.editForm.rotationStart = rotationStart
          }
        }
        if (item.overwriteRotationEnd) {
          const rotationEnd = `${moment(item.overwriteRotationEnd).utc().format('YYYY-MM-DD')}`
          if (rotationEnd !== '0001-01-01') {
            if (!this.editForm.showRotation) {
              this.editForm.showRotation = true
              this.selectedFields.push(3)
            }
            this.editForm.rotationEnd = rotationEnd
          }
        }

        /*

          if (n === 4) {
            this.editForm.showPosters = true
          }
         */

        /*
      overwritePictureVertical: item.overwrite_picture_vertical || '',
      overwritePictureHorizontal: item.overwrite_picture_horizontal || '',
         */
        /*

          verticalPosterURL: '',
          horizontalPosterURL: '',
          showPosters: false,
         */
      },
      addSeries () {
        this.newSeriesDialog = true
      },
      closeNewSeriesDialog () {
        this.newSeriesDialog = false
        this.newSeries.name = ''
        this.newSeries.description = ''
      },
      addNewSeries () {
        this.editLoading = true

        const created = {
          source_id: this.source.id,
          extid: this.newSeries.name,
          name: this.newSeries.name,
          description: this.newSeries.description,
        }

        this.$store.dispatch('createSeries', created)
          .then((res) => {
            this.$store.commit('showSnackbar', {
              text: 'The item has been added',
              timeout: 3000,
              color: 'success',
            })

            const newItem = processItem(res)
            this.items.unshift(newItem)
            this.series.push(newItem)

            this.closeNewSeriesDialog()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.editLoading = false
          })
      },
      showAssetIds () {
        for (let i = 0; i < this.items.length; i += 1) {
          this.items[i].assetId = 0
        }
        if (!this.selectedProject) return

        const params = {
          instance_id: this.selectedProject.instanceId,
          source_id: this.source.id,
        }
        const assetReq = this.$store.dispatch('getItemAssets', params)

        Promise.all([assetReq])
          .then((result) => {
            const assets = result[0] || {}
            const assetMap = {}
            for (let i = 0; i < assets.length; i += 1) {
              assetMap[assets[i].item_id] = assets[i]
            }
            for (let i = 0; i < this.items.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (assetMap.hasOwnProperty(this.items[i].id)) {
                this.items[i].assetId = assetMap[this.items[i].id].asset_id
                this.items[i].deletedInSC = assetMap[this.items[i].id].deleted
              }
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 5000,
              color: 'error',
            })
          })
      },
      openURL () {
        window.open('http://', '_blank').focus()
      },
      cardView () {
        this.cardMode = true
        this.editMode = false
      },
      splitView () {
        this.editMode = false
        this.cardMode = false
      },
      editView () {
        this.cardMode = false
        this.editMode = true
      },
      changeFieldSelection () {
        this.editForm.showTitle = false
        this.editForm.showDescription = false
        this.editForm.showType = false
        this.editForm.showRotation = false
        this.editForm.showPosters = false
        for (let i = 0; i < this.selectedFields.length; i += 1) {
          const n = this.selectedFields[i]
          if (n === 0) {
            this.editForm.showTitle = true
            continue
          }
          if (n === 1) {
            this.editForm.showDescription = true
            continue
          }
          if (n === 2) {
            this.editForm.showType = true
            continue
          }
          if (n === 3) {
            this.editForm.showRotation = true
            continue
          }
          if (n === 4) {
            this.editForm.showPosters = true
          }
        }
      },
      deleteSourceInstance (sourceInstance) {
        this.instanceRemoveDialog = true
        this.deletedInstance = sourceInstance
      },
      deleteInstanceSource () {
        this.deletedInstance.loading = true

        this.$store.dispatch('removeSourceInstance', this.deletedInstance)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The instance has been updated',
              timeout: 3000,
              color: 'success',
            })
            this.deletedInstance.deleted = true
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.deletedInstance.loading = false
            this.instanceRemoveDialog = false
            this.deletedInstance = {}
          })
      },
      openDeleteItemDialog (item) {
        this.itemRemoveDialog = true
        this.deletedItem = item
      },
      deleteItem () {
        this.$store.dispatch('deleteItem', this.deletedItem)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The item has been removed',
              timeout: 3000,
              color: 'success',
            })

            for (let i = 0; i < this.items.length; i += 1) {
              if (this.items[i].id === this.deletedItem.id) {
                this.items.splice(i, 1)
                break
              }
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.itemRemoveDialog = false
            this.deletedItem = {}
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
::v-deep .table-one {
  thead.v-data-table-header {
    tr {
      &:hover {
        background-color: #f2f3f8;
      }

      th {
        span {
          font-size: 16px;
          color: #304156;
        }
      }
    }

    tr {
      td {
        padding-bottom: 20px;
        padding-top: 20px;
      }
    }
  }

  tbody {
    tr {
      &:hover {
        background-color: #f2f3f8 !important;
      }
    }
  }
}

.tabs-package {
  ::v-deep .v-tabs-bar {
    background-color: transparent !important;
  }
}
</style>
